"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUTMODE = exports.TOKENS = exports.SIZE_OPTIONS = exports.TYPE_OPTIONS = void 0;
var TYPE_OPTIONS = {
  TEXT: "text",
  NUMBER: "number",
  EMAIL: "email",
  PASSWORD: "password",
  PASSPORTID: "passportid"
};
exports.TYPE_OPTIONS = TYPE_OPTIONS;
var SIZE_OPTIONS = {
  SMALL: "small",
  NORMAL: "normal"
};
exports.SIZE_OPTIONS = SIZE_OPTIONS;
var TOKENS = {
  heightInput: "heightInput",
  fontSizeInput: "fontSizeInput",
  paddingInput: "paddingInput",
  iconSize: "iconSize"
};
exports.TOKENS = TOKENS;
var INPUTMODE = {
  NUMERIC: "numeric",
  TEL: "tel",
  DECIMAL: "decimal",
  EMAIL: "email",
  URL: "url",
  SEARCH: "search",
  TEXT: "text",
  NONE: "none"
};
exports.INPUTMODE = INPUTMODE;